import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

function VideoOverlay({ url, bounds, opacity = 1, zIndex = 1 }) {
  const map = useMap();
  const overlayRef = useRef();

  useEffect(() => {
    if (!map || !url || !bounds) return;
    if (overlayRef.current) {
      try {
        map.removeLayer(overlayRef.current);
      } catch {}
    }
    // Create leaflet video overlay
    const overlay = L.videoOverlay(url, bounds, {
      opacity,
      zIndex,
      interactive: false,
      autoplay: true,
      loop: true,
      muted: true,
      // You can add more leaflet options if needed
    });
    overlay.addTo(map);
    overlayRef.current = overlay;

    return () => {
      if (overlayRef.current) {
        try {
          map.removeLayer(overlayRef.current);
        } catch {}
        overlayRef.current = null;
      }
    };
  }, [map, url, JSON.stringify(bounds), opacity, zIndex]);

  return null;
}

export default VideoOverlay;
